import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-mail-preview-dialog',
  templateUrl: './mail-preview-dialog.component.html',
  styleUrls: ['./mail-preview-dialog.component.scss']
})
export class MailPreviewDialogComponent{
  constructor(public dialogRef: MatDialogRef<MailPreviewDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MailPreviewDialogData) {
    this.dialogRef.updatePosition({top: '0'});
  }

  onCancel(){
    this.dialogRef.close()
  }
}

export interface MailPreviewDialogData {
  isHTML: boolean;
  text: SafeHtml;
}
